/** Public settings served by the Go server at runtime, so one build works everywhere. */
export type PublicConfig = {
  supabaseUrl: string;
  supabaseAnonKey: string;
  authEmailDomain: string;
};

let pending: Promise<PublicConfig> | null = null;

export function loadConfig(): Promise<PublicConfig> {
  pending ??= fetch("/api/config").then((r) => {
    if (!r.ok) throw new Error(`GET /api/config: ${r.status}`);
    return r.json() as Promise<PublicConfig>;
  });
  return pending;
}
